import { Directive, Input, ElementRef } from '@angular/core';
export class SidebarLeftToggleDirective {
   item;
/**
 * \@method constructor
 * @param {?} elementRef
 */
constructor(
public elementRef: ElementRef
  ) {}
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[mkMenuToggle]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'item': [{ type: Input, args: ['mkMenuToggle', ] },],
};
}

function SidebarLeftToggleDirective_tsickle_Closure_declarations() {
/** @type {?} */
SidebarLeftToggleDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SidebarLeftToggleDirective.ctorParameters;
/** @type {?} */
SidebarLeftToggleDirective.propDecorators;
/** @type {?} */
SidebarLeftToggleDirective.prototype.item;
/** @type {?} */
SidebarLeftToggleDirective.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
